import React from "react";
import styled from "styled-components";
import { FlexContainer, portalColors } from "src/components";
import { CardSkeleton } from "./CardSkeleton";

const Card = styled.div`
  width: 47px;
  height: 83px;
  border: 1px solid ${portalColors.border};
  border-radius: 7px;
  box-shadow: 0px 3px 6px #00000029;
  background: ${portalColors.surface};
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CategoryImageCard = ({ src, loading }) => {
    return (
        <FlexContainer>
            <Card>
                {loading ? (
                    <CardSkeleton width="47px" height="83px" />
                ) : (
                    <Image src={src} alt="Quote Preview" />
                )}
            </Card>
        </FlexContainer>
    );
};
